import React from 'react';

/**
 * Rebellionaire lion logo rendered from the brand PNG asset.
 *
 * @param {number}  [size=48]       - Width & height in pixels.
 * @param {string}  [className]     - Extra class names.
 * @param {object}  [style]         - Extra inline styles.
 */
export default function LionLogo({ size = 48, className = '', style }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo_rebel.png`}
      alt="Rebellionaire Logo"
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        ...style,
      }}
    />
  );
}
